<template>
    <!-- 报表管理－页面 -->
    <div class="ticketSettleDetail">
        <content-view v-show="$utils.renderWhen(this,'ticketSettleDetail')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="用户票券号" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input placeholder="请输入" v-decorator="['userTicketId']"></a-input>
                    </a-form-item>
                    <a-form-item label="会员手机号" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input placeholder="请输入" v-decorator="['accountPhone']"></a-input>
                    </a-form-item>
                    <a-form-item label="票券剩余核销金额" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input-group compact >
                            <a-input-number :precision="0" class="range-input range-input-left" placeholder="请输入" v-decorator="['nowTicketBalanceFrom']" />
                            <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                            <a-input-number :precision="0" class="range-input range-input-right" placeholder="请输入" v-decorator="['nowTicketBalanceTo']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="票券剩余核销次数" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input-group compact >
                            <a-input class="range-input range-input-left" placeholder="请输入" v-decorator="['nowTicketAvailableTimesFrom']" />
                            <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                            <a-input class="range-input range-input-right" placeholder="请输入" v-decorator="['nowTicketAvailableTimesTo']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="票券已核销次数" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input-group compact >
                            <a-input class="range-input range-input-left" placeholder="请输入" v-decorator="['historyTotalVerifyTimesFrom']" />
                            <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                            <a-input class="range-input range-input-right" placeholder="请输入" v-decorator="['historyTotalVerifyTimesTo']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="票券在该门店核销次数" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input-group compact >
                            <a-input class="range-input range-input-left" placeholder="请输入" v-decorator="['historyShopVerifyTimesFrom']" />
                            <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                            <a-input class="range-input range-input-right" placeholder="请输入" v-decorator="['historyShopVerifyTimesTo']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="门店分得占比余额" :labelCol="{span:9}" :wrapperCol="{span:12}">
                        <a-input-group compact >
                            <a-input-number :precision="0" class="range-input range-input-left" placeholder="请输入" v-decorator="['shopBalanceFrom']" />
                            <a-input style="width: 42px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="至" disabled />
                            <a-input-number :precision="0" class="range-input range-input-right" placeholder="请输入" v-decorator="['shopBalanceTo']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <section class="ticketSettleDetail-cards mb16">
                    <div class="ticketSettleDetail-cards-items">
                        <span>共统计该过期票券: {{ticketDetail.allExpireUserTicketNum || 0}};</span>
                        <span>票券名称: {{ticketDetail.ticketName}}；</span>
                        <span>票券类型：{{lineType[ticketDetail.ticketType]}}；</span>
                        <span>票券总使用次数：{{ticketDetail.ticketAllUseNum || 0}}次；</span>
                        <span>余额结算门店：{{thisShopName}}；</span>
                        <span>该票券在该门店总核销次数：{{ticketDetail.thisTicketOffsetShopVerifyNum || 0}}次</span>
                        <span>该票券门店核销占比：{{ticketDetail.thisTicketVerifyRatio * 100 || 0}}% </span>
                        <span>该票券总剩余核销金额：{{ticketDetail.thisTicketAllSurplusDecimal | amountFormat}} </span>
                        <span>门店分得占比余额总计：{{ticketDetail.shopGetRatioTotalBalance | amountFormat}}</span>
                    </div>
                    <a-button type="primary" @click="exportSettleDetail">导出</a-button>
                </section>
                <a-table style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                    <span slot="index" slot-scope="index, a,b">{{b + 1}}</span>
                    <span slot="nowTicketBalance" slot-scope="index, a,b">{{index <= 0 ? 0 : index}}</span>
                    <span slot="nowTicketAvailableTimes" slot-scope="index, a,b">{{index <= 0 ? 0 : index}}</span>
                </a-table>
            </div>
            <!-- <div v-else class="wrap-container-in text-center">
                暂无内容，请先浏览其他页面~
            </div> -->
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import moment from "moment";
export default {
    name: "ticketSettleDetail",
    components: {},
    props: {},
    data() {
        const columns = [
            {
                title: "序号",
                dataIndex: "index",
                width: 75,
                scopedSlots: { customRender: "index" }
            },
            {
                title: "用户票券号",
                dataIndex: "userTicketId"
            },
            {
                title: "会员手机号",
                dataIndex: "accountPhone"
            },
            {
                title: "票券剩余核销金额",
                dataIndex: "nowTicketBalance",
                scopedSlots: { customRender: "nowTicketBalance" }
            },
            {
                title: "票券剩余核销次数",
                dataIndex: "nowTicketAvailableTimes",
                scopedSlots: { customRender: "nowTicketAvailableTimes" }
            },
            {
                title: "已核销次数",
                dataIndex: "historyTotalVerifyTimes",
                scopedSlots: { customRender: "historyTotalVerifyTimes" }
            },
            {
                title: "在该门店核销次数",
                dataIndex: "historyShopVerifyTimes",
                scopedSlots: { customRender: "historyShopVerifyTimes" }
            },
        ];
        return {
            columns,
            lineType: ["", "期限卡", "次卡", "套餐票"],
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            shopList: [],
            type: 1,
            loading: false,
            initialValueDate: [],
            ticketDetail: {},
            name: "",
            shopId: 0,
        };
    },
    computed: {
        // ...mapGetters(["shopId"]);
        thisShopName() {
            let shops = this.shopList.find( el => {
                return el.id == this.ticketDetail.shopId;
            });
            if (shops) {
                return shops.name;
            } else {
                return "-";
            }
        }
    },
    filters: {
        amountFormat(val) {
            if (!val) {
                return "0.00"
            } else {
                return val.toFixed(2);
            }
        }
    },
    methods: {
        moment,
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        handleReset () {
            this.form.resetFields();
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        // 获取页面表格
        getList() {
            this.form.validateFields((err, values) => {
                if (err) return;
                let valuesForm = {
                    ...values,
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize,
                    shopId: this.shopId,
                    ticketId: this.$route.query.id,
                    lineType: this.$route.query.lineType,
                }
                this.$api.statement.ticketSettleDetail({
                    body: valuesForm,
                }).then(res => {
                    this.dataSource = res.data;
                    this.pagination.total = res.total;
                    this.ticketDetail = res.extraData || {};
                })
                
            });
        },
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res;
            });
        },
        // 余额明细导出
        exportSettleDetail() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.exportLoading = true;
                    this.$api.statement.exportSettleDetail({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId,
                            ticketId: this.$route.query.id,
                            lineType: this.$route.query.lineType,
                        }
                    }, {responseType: "blob"}).then( res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        this.downloadUrl = window.URL.createObjectURL(blob);
                        this.name = this.ticketDetail.ticketName;
                        let name = this.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.exportLoading = false
                    });
                }
            });
            
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {
        this.shopId = this.$route.query.shopId;
    },
    mounted() {
        this.getList();
        this.getShopList();
    }
};
</script>
<style lang="scss">
.ticketSettleDetail {
    .wrap-header .ant-form-item .ant-form-item-label {
        width: 158px;
    }
    .wrap-header .ant-form-item .ant-form-item-control-wrapper {
        width: 240px;
    }
    .wrap-header-button {
        width: 100%;
        padding: 0 24px;
    }
    width: 100%;
    &-cards {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        &-items {
            flex: 1;
            span {
                display: inline-block;
                margin-right: 50px; 
            }
        }
    }
}
</style>